import { Capacitor } from '@capacitor/core';

/**
 * Draait de web-app in de native schil (MOB-0, ADR-0083)?
 *
 * De app laadt dezelfde schermen van de server als de browser. Een paar dingen horen daar niet:
 * de uitleg "zet de app op je beginscherm" (dat is ze al), en de vraag om web push (de app krijgt
 * native push, MOB-1). `Capacitor` bestaat in de browser ook, als lege schil - dan is dit `false`.
 */
export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}
